import React from "react";
import "./Projects.css";

const Project = (props) => {
  const { title, description, img, github, liveServer } = props.project;
  return (
    <div className='col-sm-6 col-md-4 mb-3'>
      <div className='card project-card'>
        <img className='card-img-top' src={img} alt='Card cap' />
        <div className='card__bg'>
          <div className='card-body text-center'>
            <h4 className='card-title text-white'>{title}</h4>
            <p className='card-text'>
              <small className='text-white'>{description}</small>
            </p>
          </div>
          <div className='card-footer project-card-footer'>
            <a
              class='btn btn-outline-danger btn-block'
              href={github}
              target='_blank'
              role='button'
            >
              <strong>GitHub</strong>
            </a>
            <a
              class='btn btn-danger btn-block'
              href={liveServer}
              target='_blank'
              role='button'
            >
              Website
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Project;
